import { RouteName } from "@/lib/router/routes";
import useAuthStore from "@/stores/useAuthStore";
import { storeToRefs } from "pinia";
import { Router } from "vue-router";

export default function (router: Router) {
  const {
    isSignedIn,
  } = storeToRefs(useAuthStore());

  const ungatedRouteNames = [
    RouteName.login,
    RouteName.redirecting,
    RouteName.supporter,
  ];

  router.beforeEach(async (to) => {
    if (!isSignedIn.value && !ungatedRouteNames.includes(to.name as RouteName)) {
      return {
        name: RouteName.login,
        query: {
          ...to.query,
          redirect: encodeURIComponent(to.fullPath),
        },
      };
    }
  });
}
